export class ContactUs {
  fullName:string;
  email:any;
  inquiryPurposeId:number;
  message:string
}
